export default function formatFollowersNumber(number) {
  if (number >= 1000000) return intlFormat(number / 1000000) + 'M';
  if (number >= 1000) return intlFormat(number / 1000) + 'k';
  return intlFormat(number);
}

const intlFormat = (number) =>
  new Intl.NumberFormat().format(Math.round(number * 10) / 10);
